module.exports = __webpack_public_path__ + "static/img/k24_kt_03.14249985.png";